import { Autocomplete, CircularProgress, InputAdornment, TextField, Typography } from '@mui/material';

import React from 'react';
import SearchIcon from '@mui/icons-material/Search';
import tid, { TID_ATTR } from '@/common/infrastructure/config/tid';

interface LocationSearchInputProps {
  inputValue: string;
  suggestions: google.maps.places.AutocompleteSuggestion[];
  isLoading: boolean;
  onInputChange: (value: string) => void;
  onSuggestionSelect: (suggestion: google.maps.places.AutocompleteSuggestion) => void;
}

export const LocationSearchInput: React.FC<LocationSearchInputProps> = ({
  inputValue,
  suggestions,
  isLoading,
  onInputChange,
  onSuggestionSelect
}) => {
  return (
    <Autocomplete
      fullWidth
      freeSolo
      options={suggestions}
      getOptionLabel={(option) => (typeof option === 'string' ? option : (option.placePrediction?.text.text ?? ''))}
      inputValue={inputValue}
      onInputChange={(_, value) => onInputChange(value)}
      onChange={(_, value) => {
        if (value && typeof value !== 'string') {
          onSuggestionSelect(value);
        }
      }}
      filterOptions={(x) => x}
      disablePortal={true}
      {...tid('map:location-search')}
      renderInput={(params) => (
        <TextField
          inputProps={{
            ...params.inputProps,
            'aria-label': 'Location Search',
            [TID_ATTR]: 'map:location-search:input'
          }}
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <InputAdornment position="start" sx={{ ml: 1 }}>
                <SearchIcon color="action" />
              </InputAdornment>
            ),
            endAdornment: (
              <>
                {isLoading && <CircularProgress color="inherit" size={20} />}
                {params.InputProps?.endAdornment}
              </>
            )
          }}
          fullWidth
          size="small"
          placeholder="Location Search"
          variant="outlined"
        />
      )}
      renderOption={(props, option) => {
        const { key, ...otherProps } = props;
        return (
          <li key={key} {...otherProps}>
            <Typography noWrap>{option.placePrediction?.text.text ?? ''}</Typography>
          </li>
        );
      }}
    />
  );
};
